<div class="recover-password">
  <div class="recover-password__header">
    <div class="recover-password__icon-background">
      <i class="fa-regular fa-key recover-password__icon" aria-hidden="true"></i>
    </div>
    <div class="recover-password__title">{{ 'login.recovery.by-password.title' | translate }}</div>
  </div>

  <div class="recover-password__content">
    <div class="recover-password__description">{{ 'login.recovery.by-password.description' | translate }}</div>

    <div class="recover-password__input">
      <kds-input
        elementId="username"
        [label]="'login.recovery.controls.user-name' | translate"
        [componentFormControl]="recoveryForm.controls.username"
      >
        <a kds-link kdsPrefetch [routerLink]="['/', ApplicationPath.CannotLogin, LoginRecoveryPath.ForgotUsername]">
          {{ 'login.recovery.by-username.title' | translate }}
        </a>
      </kds-input>
    </div>

    <div class="recover-password__input">
      <kds-input
        elementId="organizationName"
        [label]="'login.recovery.controls.company-name' | translate"
        [componentFormControl]="recoveryForm.controls.companyName"
      >
        <a kds-link kdsPrefetch [routerLink]="['/', ApplicationPath.CannotLogin, LoginRecoveryPath.ForgotCompanyName]">
          {{ 'login.recovery.by-company-name.title' | translate }}
        </a>
      </kds-input>
    </div>

    <div class="recover-password__buttons">
      <kds-large-button
        [buttonText]="'login.recovery.buttons.continue' | translate"
        [loading]="loading()"
        [disabled]="recoveryForm.invalid"
        (buttonClick)="recoverCredentials()"
      />
      <kds-large-button
        colorScheme="tertiary"
        [buttonText]="'login.recovery.buttons.back-to-login' | translate"
        (buttonClick)="backToLogin()"
      />
    </div>
  </div>
</div>
